import AutoReplace from 'slate-auto-replace';
import SoftBreak from 'slate-soft-break';
import EditCode from 'slate-edit-code';
import EditBlockquote from 'slate-edit-blockquote';
import PrismHighlight from 'slate-prism';
import EditList from 'slate-edit-list';

// XXX(thx):
// EditCode needs following modifications:
// + replaces noOrphanLine rule with unsetOrphanLine. (re-implemented)
// + onBackspace when deleting from isStartOfCode
// + in makeSchema, update to use mergeNodeByKey (vs joinNodeByKey)

// XXX(thx):
// EditBlockquote may need to be patched to fix unwrapping
// behavior on onBackspace because startOffset === 0
// is unreliable when there are inlines in the blockquote.

// XXX(thx): EditList modified for:
// + "maxDepth" in onTab

import {
  NODE_TYPE as NT,
  TYPEAHEAD_ACTION as TA,
} from 'shared/constants/slate';
import { loadPrismLangs } from 'shared/helpers';

import PatchDeleteIntoTargetTypes from './PatchDeleteIntoTargetTypes';
// import PatchEditWhileExpanded from './PatchEditWhileExpanded';
import { TrimSelection } from './TrimSelection';
import { PatchUndo } from './PatchUndo';
import PatchHardBreakOnInline from './PatchHardBreakOnInline';
import AutoReplaceRules from './AutoReplaceRules';
import { hotkeyMatcher, SetHotkey_ToggleMark } from './SetHotkey';
import { EditHeading } from './EditHeading';
import onPasteGuessSyntax from './onPasteGuessSyntax';
import { TrimDocumentOnBlur } from './TrimDocumentOnBlur';
import { AutoTypeahead } from './AutoTypeahead';
import { DropOrPasteImage, onFileLoadInsertImageSrc } from './DropOrPasteImage';
import { HandleImage } from './HandleImage';
import { HandleReceiver } from './HandleReceiver';

import { onlyCollapsedInTopLevelParagraph, } from '../utils';



// NOTE(thx): Call this after all imports, including 'slate-prism'.
loadPrismLangs();



const editListOpts = {
  types: [NT.ul, NT.ol],
  typeItem: NT.li,
  typeDefault: NT.paragraph,
};

const editCodeOpts = {
  containerType: NT.codeBlock,
  lineType: NT.codeLine,
  exitBlockType: NT.paragraph,
  selectAll: true,
  allowMarks: false,
};

const editBlockquoteOpts = {
  type: NT.blockquote,
  typeDefault: NT.paragraph,
};


// + trigger and before are required.
// + should be only one regex group in before for capture
const autoTypeaheadOtps = {
  mapper: {
    [TA.command]: {
      trigger: '/' ,
      before: /^\/(\w*)$/,
      after: /^\s*$/,

      // For now, only fuction is supported..
      onlyIn: value => onlyCollapsedInTopLevelParagraph(value),
    },

    // Another example..
    // mention: { trigger: '@' , capture: /^\/(\w*)$/ },
  },
};


export {
  SoftBreak,
  hotkeyMatcher,
  SetHotkey_ToggleMark,
  AutoReplace,
  AutoReplaceRules,

  HandleImage,
  HandleReceiver,

  DropOrPasteImage,
  onFileLoadInsertImageSrc,

  // EditLink,
  EditHeading,

  EditList,
    editListOpts,

  EditBlockquote,
    editBlockquoteOpts,

  EditCode,
    editCodeOpts,

  PrismHighlight,
  onPasteGuessSyntax,
  // PatchEditWhileExpanded,

  TrimDocumentOnBlur,
  TrimSelection,
  PatchUndo,
  PatchDeleteIntoTargetTypes,
  PatchHardBreakOnInline,

  AutoTypeahead,
    autoTypeaheadOtps,
};



// WEBPACK FOOTER //
// ./src/components/slate/plugins/index.js